import { $fontSize } from "@/utils/cssVarUtils"
import { cssVar, SystemStyleObject } from "@chakra-ui/theme-tools"


const $size = cssVar("spinner-size")

const baseStyle: SystemStyleObject = {
  width: [$size.reference],
  height: [$size.reference],
}

const sizes: Record<string, SystemStyleObject> = {
  xs: {
    [$size.variable]: $fontSize('md'),
  },
  sm: {
    [$size.variable]: $fontSize('2xl'),
  },
  md: {
    [$size.variable]: $fontSize('5xl'),
  },
  lg: {
    [$size.variable]: $fontSize('10xl'),
  },
}

const defaultProps = {
  size: "md",
}

export const Spinner = {
  baseStyle,
  sizes,
  defaultProps,
}